import { Component, Input, OnInit } from '@angular/core';
import { NavigationItemEntity } from '@/app/platform/platform-data/models/navigation-item.entity';

@Component({
    selector: 'navigation-item-label[navigationItem]',
    templateUrl: './navigation-item-label.component.html',
    styleUrls: ['./navigation-item-label.component.css'],
    standalone: false
})
export class NavigationItemLabelComponent implements OnInit {
  @Input() navigationItem: NavigationItemEntity;

  constructor() {}

  ngOnInit(): void {}
}
